import { render, staticRenderFns } from "./ImageHotspot.vue?vue&type=template&id=90c58f8c&scoped=true&"
import script from "./ImageHotspot.vue?vue&type=script&lang=js&"
export * from "./ImageHotspot.vue?vue&type=script&lang=js&"
import style0 from "./ImageHotspot.vue?vue&type=style&index=0&id=90c58f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c58f8c",
  null
  
)

export default component.exports